import { ProductionCollection } from 'types/sanity.types';

export const toClassName = (...values: (boolean | string | undefined)[]) => {
  return values.filter(Boolean).join(' ');
};

export const handleGenerateInitialsFromName = (name: string) => {
  let result = name;

  if (name) {
    result = name.charAt(0);
  }

  return result;
};

// export const handleFormatDate = (date: string, t: any) => {
//   const dateObject = new Date(date);
//   return `${dateObject.getDate()} ${t(`enum.date.month.${dateObject.getMonth()}`)} ${dateObject.getFullYear()}`;
// };

export const handleFormatDate = (
  date: string,
  t: (key: string) => string,
): string => {
  if (!date) return '';
  if (date === 'Now') return 'Nu'; // <-- safely handle this special case

  const dateObject = new Date(date);
  if (isNaN(dateObject.getTime())) return '';

  return `${dateObject.getDate()} ${t(`enum.date.month.${dateObject.getMonth()}`)} ${dateObject.getFullYear()}`;
};

export const handleConvertToLocale = (lang: string) => {
  let result = lang;

  switch (lang) {
    case 'nl':
      result = 'nl-BE';
      break;
    case 'fr':
      result = 'fr-BE';
      break;
    case 'en':
      result = 'en';
      break;
  }

  return result;
};

export const formatDateToStringToCat = (dateObj: Date, t: any) => {
  if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) return '';

  const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  return `${t(`enum.day.${days[dateObj.getDay()]}`)} ${String(
    dateObj.getMonth() + 1,
  ).padStart(2, '0')}.${String(dateObj.getDate()).padStart(2, '0')}`;
};

export const convertDateToHHmm = (dateObj: Date) => {
  if (!(dateObj instanceof Date) || isNaN(dateObj as any)) {
    console.error('Invalid input: Please provide a valid Date object.');
    return '';
  }

  const hours = `0${dateObj.getHours()}`.slice(-2);
  const minutes = `0${dateObj.getMinutes()}`.slice(-2);

  return `${hours}:${minutes}`;
};

// export const handleGetFromDateFromPlayDates = (
//   playDates:
//     | {
//         date?: string | undefined;
//         location?: string | undefined;
//         url?: string | undefined;
//         _key: string;
//       }[]
//     | undefined,
// ) =>
//   [...(playDates ?? [])]
//     .map((playDate) => playDate.date)
//     .filter((item) => item !== undefined)
//     .sort((a, b) => (a < b ? -1 : 1))[0];

// export const handleGetToDateFromPlayDates = (
//   playDates:
//     | {
//         date?: string | undefined;
//         location?: string | undefined;
//         url?: string | undefined;
//         _key: string;
//       }[]
//     | undefined,
// ) =>
//   [...(playDates ?? [])]
//     .map((playDate) => playDate.date)
//     .filter((item) => item !== undefined)
//     .sort((a, b) => (a > b ? -1 : 1))[0];

export const handleGetFromDateFromPlayDates = (
  playDates?: {
    date?: string;
    location?: string;
    url?: string;
    _key: string;
  }[],
): string | undefined => {
  if (!playDates || playDates.length === 0) return undefined;

  const validDates: any = playDates
    .map((p) => p.date)
    .filter((d): d is string => !!d)
    .map((d) => new Date(d))
    .filter((d) => !isNaN(d.getTime()))
    .sort((a, b) => a.getTime() - b.getTime()); // oldest → newest

  if (validDates.length === 0) return undefined;

  const now = Date.now();
  const weekInMs = 7 * 24 * 60 * 60 * 1000;

  // Find the first playdate in the future (the closest one)
  const upcoming = validDates.find((d: any) => d.getTime() > now);

  if (upcoming) {
    const diff = upcoming.getTime() - now;

    // If next play date is within the next 7 days → show "Now"
    if (diff <= weekInMs) return 'Now';

    // Else → show that date explicitly
    return upcoming.toISOString();
  }

  // No future playdates: return earliest (past) date
  return validDates[0].toISOString();
};

export const handleGetToDateFromPlayDates = (
  playDates?: {
    date?: string;
    location?: string;
    url?: string;
    _key: string;
  }[],
): string | undefined => {
  if (!playDates || playDates.length === 0) return undefined;

  const validDates = playDates
    .map((p) => p.date)
    .filter((d): d is string => !!d)
    .map((d) => new Date(d))
    .filter((d) => !isNaN(d.getTime()));

  if (validDates.length === 0) return undefined;

  const latest: any = validDates.sort((a, b) => b.getTime() - a.getTime())[0];
  return latest.toISOString();
};

export const sortByDate = (
  items: any[],
  order: 'asc' | 'desc' = 'asc',
): any[] => {
  return [...items].sort((a, b) => {
    const dateA = a.date instanceof Date ? a.date : new Date(a.date);
    const dateB = b.date instanceof Date ? b.date : new Date(b.date);

    if (order === 'asc') {
      return dateA.getTime() - dateB.getTime();
    } else {
      return dateB.getTime() - dateA.getTime();
    }
  });
};

export const handleGetPremiereYear: any = (item?: ProductionCollection) =>
  item && item.playDates !== undefined && item.playDates?.length > 0
    ? new Date(sortByDate(item.playDates ?? [])[0]?.date).getFullYear()
    : undefined;
